import React from 'react';
import Header from './Header';
import PantallaCuentas from './PantallaCuentas'

const SeleccionCuentas = ({ cuentas, isFetching, error, getExisteSolicitudCuenta, saveData, clearCuentaActual, plasticos, data, borrarTarjeta, reimprimirTarjeta, reimprimirPin, modificarSolicitud, deleteSolicitudPendiente, mostrarAlertaProcesoFinalizado, agregarQuitarCuentaVinculo, grabarVinculacion, cambiarCuentaPrincipal, GetVinculosByNroTarjeta, mostrarVinculos, getHistorialMovimiento, crearModificarSolicitudTarjeta, getSolicitudesTarjetaByTarjetaId, UserId, getVinculaciones, borrarVinculo, mostrarOcultarModalVinculos }) => {

    if (isFetching || error)
        return <p>Cargando....</p>;

    if (plasticos.clienteResultadoBusqueda.BloqueoDescripcion == 'OK' && plasticos.clienteResultadoBusqueda.BloqueoCodigo == 'OK') {
        return (
            <div>
                <div>
                    <PantallaCuentas
                        data={data}
                        getExisteSolicitudCuenta={getExisteSolicitudCuenta}
                        clearCuentaActual={clearCuentaActual}
                        plasticos={plasticos}
                        borrarTarjeta={borrarTarjeta}
                        reimprimirTarjeta={reimprimirTarjeta}
                        reimprimirPin={reimprimirPin}
                        modificarSolicitud={modificarSolicitud}
                        deleteSolicitudPendiente={deleteSolicitudPendiente}
                        mostrarAlertaProcesoFinalizado={mostrarAlertaProcesoFinalizado}
                        agregarQuitarCuentaVinculo={agregarQuitarCuentaVinculo}
                        grabarVinculacion={grabarVinculacion}
                        cambiarCuentaPrincipal={cambiarCuentaPrincipal}
                        GetVinculosByNroTarjeta={GetVinculosByNroTarjeta}
                        mostrarVinculos={mostrarVinculos}
                        getHistorialMovimiento={getHistorialMovimiento}
                        crearModificarSolicitudTarjeta={crearModificarSolicitudTarjeta}
                        getSolicitudesTarjetaByTarjetaId={getSolicitudesTarjetaByTarjetaId}
                        UserId={UserId}
                        getVinculaciones={getVinculaciones}
                        borrarVinculo={borrarVinculo}
                        mostrarOcultarModalVinculos={mostrarOcultarModalVinculos}
                    />
                </div>
            </div>
        );
    } else if (plasticos.clienteResultadoBusqueda.BloqueoDescripcion == 'OK') {
        return (
            <div className="bloqueo-mensaje-delivery">
                <label>{plasticos.clienteResultadoBusqueda.BloqueoCodigo}</label>
            </div >
        );
    } else {
        return (
            <div className="bloqueo-mensaje-delivery">
                <label>{plasticos.clienteResultadoBusqueda.BloqueoDescripcion}</label>
            </div >
        );
    }
}

export default SeleccionCuentas;
